import { Component } from '@angular/core';


@Component({
  standalone: false,
  selector: 'xform-404',
  templateUrl: './page-not-found.component.html'
})
export class PageNotFoundComponent {}
